let stripePubKey = '';
let stripeSecretKey = '';
if (process.env.VUE_APP_ENV === 'production') {
  stripePubKey = 'pk_live_Z0Onw8jeRXw4VALji8Z66z4800CM7rgQKv';
  stripeSecretKey = '';
} else {
  stripePubKey = 'pk_test_MsUayPrijh9Kis4m2IqpOlsk00YzYaRNZy';
  stripeSecretKey = '';
}

const STRIPE_PUB_KEY = stripePubKey;
const STRIPE_SECRET_KEY = stripeSecretKey;

export {
  STRIPE_PUB_KEY,
  STRIPE_SECRET_KEY
};
